<script>
import { Doughnut } from "vue-chartjs";
const options = {
  responsive: true,
  maintainAspectRatio: false,
  cutoutPercentage: 50,
  legend: {
    position: "right",
    //fullWidth:true,
    labels: {
      fontColor: "black",
      padding: 10,
      //boxWidth:100
    },
  },
};
export default {
  extends: Doughnut,

  props: ["chartData", "options"],

  mounted() {
    this.addPlugin({
      id: "my-plugin",
      beforeInit: function (chart, options) {
        chart.legend.afterFit = function () {
          this.width = this.width + 30;
        };
      },
      beforeDraw: function (chart) {
        if (chart.data.datasets[0].data.length > 0) {
          let total = chart.data.datasets[0].data.reduce((a, b) => {
            return a + b;
          });
          chart.legend.legendItems.forEach((label) => {
            let value = chart.data.datasets[0].data[label.index];
            label.text =
              chart.data.labels[label.index] +
              " - " +
              ((value / total) * 100).toFixed(0) +
              "%";
            return label;
          });
        }

      },
    });
  },
  watch: {
    chartData: {
      handler(n, o) {
        //console.log(n)
        this.renderChart(n, options);
      },
      deep: true,
    },
  },
  // computed: {
  //   _chartData() {
  //     return this.chartData;
  //   },
  // },
  methods: {
    update() {
      this.$data._chart.update();
    },
  },
};
</script>